var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _g, _g2, _path3, _path4, _path5, _rect6, _rect7, _rect8, _path6, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404 = function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h280v238H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.4507,
    y: 4.68311,
    width: 140,
    height: 228.732,
    rx: 11.831,
    fill: "#D8DBE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8872,
    y: 9.11972,
    width: 131.127,
    height: 219.859,
    rx: 9.85915,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.328 144.19c2.276-3.944 7.969-3.944 10.246 0l26.895 46.585c2.277 3.943-.569 8.873-5.123 8.873h-53.791c-4.554 0-7.4-4.93-5.123-8.873l26.896-46.585Z",
    fill: "#E7E9F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 86.7605,
    y: 30.8099,
    width: 113.38,
    height: 26.6197,
    rx: 9.85915,
    fill: "#D8DBE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 86.7605,
    y: 61.3732,
    width: 113.38,
    height: 55.2113,
    rx: 9.85915,
    fill: "#D8DBE5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7605,
    y: 120.528,
    width: 113.38,
    height: 99.5775,
    rx: 9.85915,
    stroke: "#D8DBE5",
    strokeWidth: 0.985915,
    strokeLinecap: "round",
    strokeDasharray: "3.94 3.94"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.7605,
    y: 39.1901,
    width: 113.38,
    height: 131.127,
    rx: 9.85915,
    fill: "#fff",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.6196,
    y: 49.0493,
    width: 93.662,
    height: 59.1549,
    rx: 7.88732,
    fill: "#F56819",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1898 86.0127v-4.898l11.2158-16.0429h6.7792v15.6879h2.9104v5.253h-2.9104v4.6141h-6.0693v-4.6141H39.1898Zm12.3516-14.2682-5.9628 9.0152h5.9628v-9.0152Zm11.5266 5.5724c0-4.0699.7808-7.2761 2.3425-9.6186 1.5854-2.3425 4.1291-3.5138 7.631-3.5138 3.502 0 6.0338 1.1713 7.5955 3.5138 1.5854 2.3425 2.378 5.5487 2.378 9.6186 0 4.1172-.7926 7.347-2.378 9.6896-1.5617 2.3425-4.0935 3.5138-7.5955 3.5138-3.5019 0-6.0456-1.1713-7.631-3.5138-1.5617-2.3426-2.3425-5.5724-2.3425-9.6896Zm13.9842 0c0-2.3899-.2603-4.2237-.7808-5.5014-.5206-1.3014-1.5972-1.9521-3.2299-1.9521-1.6327 0-2.7093.6507-3.2298 1.9521-.5206 1.2777-.7809 3.1115-.7809 5.5014 0 1.609.0947 2.9459.284 4.0107.1893 1.0411.5679 1.893 1.1357 2.5555.5916.6389 1.4552.9583 2.591.9583 1.1358 0 1.9876-.3194 2.5555-.9583.5916-.6625.982-1.5144 1.1713-2.5555.1893-1.0648.2839-2.4017.2839-4.0107Zm9.3114 8.6958v-4.898l11.2158-16.0429h6.7796v15.6879h2.91v5.253h-2.91v4.6141h-6.0698v-4.6141H86.3636Zm12.3515-14.2682-5.9628 9.0152h5.9628v-9.0152Z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2806 136.314c-1.5617 0-2.9972-.363-4.3065-1.089-1.2935-.726-2.3268-1.735-3.0997-3.029-.7572-1.309-1.1358-2.776-1.1358-4.401s.3786-3.084 1.1358-4.377c.7729-1.294 1.8062-2.303 3.0997-3.029 1.3093-.726 2.7448-1.088 4.3065-1.088 1.5617 0 2.9893.362 4.2828 1.088 1.3093.726 2.3346 1.735 3.0761 3.029.7571 1.293 1.1357 2.752 1.1357 4.377s-.3786 3.092-1.1357 4.401c-.7572 1.294-1.7826 2.303-3.0761 3.029-1.2935.726-2.7211 1.089-4.2828 1.089Zm0-3.692c1.3251 0 2.382-.441 3.1707-1.325.8045-.883 1.2067-2.051 1.2067-3.502 0-1.467-.4022-2.634-1.2067-3.502-.7887-.883-1.8456-1.325-3.1707-1.325-1.3409 0-2.4135.434-3.218 1.302-.7888.867-1.1831 2.042-1.1831 3.525 0 1.467.3943 2.642 1.1831 3.526.8045.867 1.8771 1.301 3.218 1.301Zm19.7845 3.692c-1.5617 0-2.9972-.363-4.3064-1.089-1.2936-.726-2.3268-1.735-3.0998-3.029-.7571-1.309-1.1357-2.776-1.1357-4.401s.3786-3.084 1.1357-4.377c.773-1.294 1.8062-2.303 3.0998-3.029 1.3092-.726 2.7447-1.088 4.3064-1.088s2.9893.362 4.2828 1.088c1.3093.726 2.3347 1.735 3.0761 3.029.7572 1.293 1.1358 2.752 1.1358 4.377s-.3786 3.092-1.1358 4.401c-.7572 1.294-1.7825 2.303-3.0761 3.029-1.2935.726-2.7211 1.089-4.2828 1.089Zm0-3.692c1.3251 0 2.382-.441 3.1707-1.325.8045-.883 1.2068-2.051 1.2068-3.502 0-1.467-.4023-2.634-1.2068-3.502-.7887-.883-1.8456-1.325-3.1707-1.325-1.3408 0-2.4135.434-3.218 1.302-.7887.867-1.1831 2.042-1.1831 3.525 0 1.467.3944 2.642 1.1831 3.526.8045.867 1.8772 1.301 3.218 1.301Zm24.588-7.737c0 .962-.2209 1.845-.6626 2.65-.4417.789-1.12 1.428-2.0349 1.917-.9149.489-2.0507.733-3.4073.733h-2.5082v5.963h-4.0462v-16.611h6.5544c1.325 0 2.445.229 3.36.686.9149.458 1.6011 1.089 2.0586 1.893.4574.805.6862 1.728.6862 2.769Zm-6.4124 2.082c.7729 0 1.3487-.181 1.7273-.544.3786-.363.5679-.876.5679-1.538 0-.663-.1893-1.175-.5679-1.538-.3786-.363-.9544-.544-1.7273-.544h-2.2006v4.164h2.2006Zm15.7123 9.347c-1.2149 0-2.3033-.198-3.2656-.592-.9622-.394-1.7352-.978-2.3189-1.751-.5678-.773-.8676-1.704-.8991-2.792h4.3065c.0631.615.276 1.088.6388 1.42.3629.315.8363.473 1.4193.473.6 0 1.073-.134 1.42-.402.347-.284.521-.671.521-1.16 0-.41-.142-.749-.426-1.017-.268-.268-.607-.489-1.018-.663-.394-.173-.962-.371-1.7033-.591-1.0727-.332-1.9482-.663-2.6265-.994-.6783-.331-1.2619-.82-1.751-1.467-.489-.647-.7335-1.491-.7335-2.532 0-1.546.56-2.753 1.68-3.62 1.12-.884 2.5792-1.325 4.3773-1.325 1.83 0 3.305.441 4.425 1.325 1.12.867 1.719 2.082 1.798 3.644h-4.377c-.032-.537-.229-.955-.592-1.255-.363-.315-.828-.473-1.396-.473-.4888 0-.8832.134-1.1829.403-.2997.252-.4496.623-.4496 1.112 0 .536.2524.954.7572 1.254.5053.299 1.2933.623 2.3663.97 1.073.363 1.94.71 2.603 1.041.678.331 1.262.812 1.751 1.443.489.631.733 1.444.733 2.438 0 .946-.244 1.806-.733 2.579-.474.773-1.168 1.388-2.083 1.845-.914.458-1.995.687-3.241.687Z",
    fill: "#040B20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0239 149.886c0 .348-.0822.677-.2465.986-.1643.309-.4272.562-.7887.759-.3615.191-.8249.286-1.3901.286h-1.2423v2.78h-1.1239v-6.852h2.3662c.5258 0 .9694.092 1.3309.276.3681.178.6409.421.8183.73.1841.309.2761.654.2761 1.035ZM38.5986 151c.4272 0 .746-.095.9563-.286.2103-.197.3155-.473.3155-.828 0-.749-.424-1.124-1.2718-1.124h-1.2423V151h1.2423Zm3.1226.956c0-.545.1117-1.028.3352-1.449.2301-.421.539-.746.9268-.976.3943-.237.8282-.355 1.3014-.355.4272 0 .7986.086 1.1141.256.322.165.5784.372.769.622v-.789h1.1338v5.432h-1.1338v-.808c-.1906.256-.4502.47-.7789.641-.3286.17-.7033.256-1.1239.256-.4667 0-.8939-.118-1.2817-.355-.3878-.243-.6967-.578-.9268-1.006-.2235-.433-.3352-.923-.3352-1.469Zm4.4465.02c0-.375-.0789-.7-.2366-.976-.1512-.276-.3517-.486-.6014-.631-.2498-.145-.5193-.217-.8085-.217s-.5587.072-.8084.217c-.2498.138-.4536.345-.6113.621-.1512.27-.2268.592-.2268.966 0 .375.0756.704.2268.986.1577.283.3615.5.6113.651.2563.145.5258.217.8084.217.2892 0 .5587-.072.8085-.217.2497-.145.4502-.355.6014-.631.1577-.283.2366-.611.2366-.986Zm4.7988-2.8c.4206 0 .792.086 1.1141.256.3286.165.5849.372.769.622v-.789h1.1338v5.521c0 .499-.1052.943-.3155 1.331-.2103.394-.516.703-.9169.927-.3944.223-.8676.335-1.4197.335-.7362 0-1.3475-.174-1.8338-.523-.4864-.341-.7625-.808-.8282-1.4h1.1141c.0854.283.2662.51.5422.681.2827.177.6179.266 1.0057.266.4535 0 .8183-.138 1.0943-.414.2827-.276.424-.677.424-1.203v-.907c-.1906.256-.4503.473-.7789.651-.3221.17-.6901.256-1.1042.256-.4733 0-.9071-.118-1.3014-.355-.3878-.243-.6967-.578-.9268-1.006-.2235-.433-.3352-.923-.3352-1.469 0-.545.1117-1.028.3352-1.449.2301-.421.539-.746.9268-.976.3943-.237.8281-.355 1.3014-.355Zm1.8831 2.8c0-.375-.0789-.7-.2366-.976-.1512-.276-.3517-.486-.6015-.631-.2497-.145-.5192-.217-.8084-.217s-.5587.072-.8085.217c-.2497.138-.4535.345-.6112.621-.1512.27-.2268.592-.2268.966 0 .375.0756.704.2268.986.1577.283.3615.5.6112.651.2564.145.5259.217.8085.217.2892 0 .5587-.072.8084-.217.2498-.145.4503-.355.6015-.631.1577-.283.2366-.611.2366-.986Zm7.5889-.128c0 .204-.0131.388-.0394.552h-4.1507c.0328.434.1939.782.4831 1.045.2892.263.6441.394 1.0648.394.6046 0 1.0319-.253 1.2816-.759h1.2127c-.1643.5-.4634.911-.8972 1.233-.4272.315-.9596.473-1.5971.473-.5193 0-.986-.115-1.4-.345-.4076-.237-.7296-.565-.9662-.986-.2301-.427-.3451-.92-.3451-1.479s.1117-1.048.3352-1.469c.23-.427.5488-.756.9563-.986.4141-.23.8874-.345 1.4198-.345.5126 0 .9694.112 1.3704.335.4009.224.7131.539.9366.947.2235.401.3352.864.3352 1.39Zm-1.1732-.355c-.0066-.414-.1545-.746-.4437-.996s-.6474-.374-1.0746-.374c-.3878 0-.7198.124-.9958.374-.2761.243-.4404.575-.493.996h3.0071Zm7.5812-2.317c.4272 0 .8084.089 1.1437.266.3417.178.6079.441.7985.789.1907.348.286.769.286 1.262v3.204h-1.1141v-3.036c0-.487-.1216-.858-.3648-1.115-.2432-.262-.5751-.394-.9958-.394-.4206 0-.7559.132-1.0056.394-.2432.257-.3648.628-.3648 1.115v3.036h-1.1239v-5.432h1.1239v.621c.184-.224.4174-.398.7-.523.2892-.124.5948-.187.9169-.187Zm6.0182 5.61c-.5127 0-.9761-.115-1.3902-.345-.4141-.237-.7394-.565-.976-.986-.2367-.427-.355-.92-.355-1.479 0-.552.1216-1.042.3648-1.469.2432-.427.5751-.756.9958-.986.4207-.23.8906-.345 1.4099-.345.5192 0 .9892.115 1.4098.345.4207.23.7526.559.9958.986.2432.427.3648.917.3648 1.469s-.1249 1.042-.3747 1.469c-.2497.427-.5915.759-1.0253.996-.4273.23-.9005.345-1.4197.345Zm0-.976c.2892 0 .5586-.069.8084-.207.2564-.138.4634-.345.6211-.621.1578-.276.2367-.612.2367-1.006s-.0756-.726-.2268-.996c-.1512-.276-.3516-.483-.6014-.621-.2498-.138-.5193-.207-.8085-.207s-.5586.069-.8084.207c-.2432.138-.4371.345-.5817.621-.1446.27-.2169.602-.2169.996 0 .585.1479 1.039.4437 1.361.3023.315.6802.473 1.1338.473Zm5.242-3.628v3.007c0 .203.046.351.1381.443.0985.086.2629.129.4929.129h.6902v.936h-.8874c-.5061 0-.8939-.118-1.1634-.355-.2694-.236-.4042-.621-.4042-1.153v-3.007h-.6408v-.917h.6408v-1.351h1.1338v1.351h1.3212v.917h-1.3212Zm7.1956 0h-1.0056v4.515h-1.1338v-4.515h-.6409v-.917h.6409v-.385c0-.624.1643-1.078.4929-1.36.3352-.289.8578-.434 1.5676-.434v.937c-.3418 0-.5817.065-.7197.197-.138.125-.207.345-.207.66v.385h1.0056v.917Zm3.3524 4.604c-.5127 0-.976-.115-1.3901-.345-.4141-.237-.7395-.565-.9761-.986-.2366-.427-.3549-.92-.3549-1.479 0-.552.1216-1.042.3648-1.469.2432-.427.5751-.756.9958-.986.4206-.23.8906-.345 1.4098-.345.5193 0 .9892.115 1.4099.345.4206.23.7526.559.9957.986.2432.427.3648.917.3648 1.469s-.1248 1.042-.3746 1.469c-.2498.427-.5916.759-1.0254.996-.4272.23-.9004.345-1.4197.345Zm0-.976c.2892 0 .5587-.069.8085-.207.2563-.138.4633-.345.6211-.621.1577-.276.2366-.612.2366-1.006s-.0756-.726-.2267-.996c-.1512-.276-.3517-.483-.6015-.621-.2497-.138-.5192-.207-.8084-.207s-.5587.069-.8085.207c-.2432.138-.437.345-.5816.621-.1446.27-.2169.602-.2169.996 0 .585.1478 1.039.4436 1.361.3024.315.6803.473 1.1338.473Zm8.8505-4.545v5.432h-1.1239v-.641c-.1775.224-.4108.401-.7.533-.2826.125-.585.187-.9071.187-.4272 0-.8117-.089-1.1535-.266-.3352-.178-.6014-.441-.7986-.789-.1906-.348-.2859-.769-.2859-1.262v-3.194h1.1141v3.027c0 .486.1216.861.3648 1.123.2432.257.5751.385.9958.385.4206 0 .7525-.128.9957-.385.2498-.262.3747-.637.3747-1.123v-3.027h1.1239Zm4.2238-.089c.427 0 .808.089 1.144.266.341.178.608.441.798.789.191.348.286.769.286 1.262v3.204h-1.114v-3.036c0-.487-.121-.858-.365-1.115-.243-.262-.575-.394-.995-.394-.421 0-.756.132-1.006.394-.243.257-.365.628-.365 1.115v3.036h-1.1238v-5.432h1.1238v.621c.184-.224.418-.398.7-.523.289-.124.595-.187.917-.187Zm3.287 2.78c0-.545.112-1.028.335-1.449.23-.421.539-.746.927-.976.395-.237.832-.355 1.311-.355.355 0 .704.079 1.046.237.348.151.624.355.828.611v-2.623h1.133v7.296h-1.133v-.818c-.184.263-.441.48-.769.651-.322.17-.694.256-1.114.256-.474 0-.907-.118-1.302-.355-.388-.243-.697-.578-.927-1.006-.223-.433-.335-.923-.335-1.469Zm4.447.02c0-.375-.079-.7-.237-.976-.151-.276-.352-.486-.601-.631-.25-.145-.52-.217-.809-.217-.289 0-.558.072-.808.217-.25.138-.454.345-.612.621-.151.27-.226.592-.226.966 0 .375.075.704.226.986.158.283.362.5.612.651.256.145.526.217.808.217.289 0 .559-.072.809-.217.249-.145.45-.355.601-.631.158-.283.237-.611.237-.986Z",
    fill: "#6B6E77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.352 9.11972h56.197v1.97188c0 5.445-4.414 9.8591-9.859 9.8591h-36.479c-5.445 0-9.859-4.4141-9.859-9.8591V9.11972Z",
    fill: "#D8DBE5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125.704,
    y: 10.1056,
    width: 26.6197,
    height: 5.42254,
    rx: 2.71127,
    fill: "#B1BACA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 155.281,
    y: 10.1056,
    width: 5.42254,
    height: 5.42254,
    rx: 2.71127,
    fill: "#B1BACA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 86.7605,
    y: 120.528,
    width: 113.38,
    height: 99.5775,
    rx: 9.85915,
    fill: "#E7E9F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.782 164.392c-.149-2.127 1.537-3.934 3.669-3.934s3.817 1.807 3.669 3.934l-1.033 14.804c-.097 1.385-1.248 2.459-2.636 2.459-1.388 0-2.54-1.074-2.637-2.459l-1.032-14.804Z",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140.986,
    y: 184.12,
    width: 4.92958,
    height: 4.92958,
    rx: 2.46479,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -0.000065,
    y: 23.4155,
    width: 152.817,
    height: 170.563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 2.46479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_53_23661"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.95775,
    dy: 3.94366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.85915
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.498303 0 0 0 0 0.538207 0 0 0 0 0.609147 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_53_23661",
    result: "effect2_dropShadow_53_23661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_53_23661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 18.7323,
    y: 43.1338,
    width: 109.437,
    height: 74.9296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.97183
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.464876 0 0 0 0 0.279235 0 0 0 0 0.220612 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_23661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_53_23661",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.97183,
    dy: -1.97183
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.97183
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_53_23661"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.97183,
    dy: 1.97183
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.97183
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_innerShadow_53_23661",
    result: "effect3_innerShadow_53_23661"
  })))));
};
export default Svg404;